var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralTotalundergrad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 51,
    viewBox: "0 0 34 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(-3.175 -0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6100",
    d: "M17.251.529a.85.85,0,0,0-.339.07L5.009,5.7a.85.85,0,0,0-.043,1.537l5.1,2.553a.85.85,0,0,0,.377.088h13.6a.85.85,0,0,0,.377-.088l5.1-2.553A.85.85,0,0,0,29.48,5.7L17.578.6a.85.85,0,0,0-.327-.07Z",
    transform: "translate(2.931 0)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_48088",
    "data-name": "Group 48088",
    transform: "translate(9.126 0.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6224",
    d: "M6.73,1.753l-1.7.73c0,.7,0,1.7,0,2.661L6.731,6c0-1.557,0-3.1,0-4.243Z",
    transform: "translate(-5.027 2.18)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6207",
    d: "M9.059.529A.85.85,0,0,0,8.72.6L8.2.821,19.587,5.7a.85.85,0,0,1,.045,1.537l-5.1,2.553a.85.85,0,0,1-.377.088h1.7a.85.85,0,0,0,.377-.088l5.1-2.553A.85.85,0,0,0,21.287,5.7L9.386.6a.85.85,0,0,0-.327-.07Z",
    transform: "translate(1.997 -0.529)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6190",
    d: "M14.273,2.117A10.2,10.2,0,0,0,6.843,5.323a.85.85,0,0,0-.232.584v.458H19.374a.85.85,0,0,0,.377-.088l1.934-.968a10.194,10.194,0,0,0-7.413-3.192Z",
    transform: "translate(-1.524 2.984)",
    fill: "#aee0d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6091",
    d: "M13.743,2.117A10.2,10.2,0,0,0,6.314,5.323a.85.85,0,0,0-.232.584v4.7a.85.85,0,0,0,.508.782,9.336,9.336,0,0,1,14.3.007.85.85,0,0,0,.51-.782V5.9a.85.85,0,0,0-.232-.583,10.2,10.2,0,0,0-7.422-3.2Z",
    transform: "translate(6.432 3.514)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6177",
    d: "M9.052,2.117c-.285,0-.568.02-.85.043a10.187,10.187,0,0,1,6.573,3.158.85.85,0,0,1,.232.583v4.323A9.35,9.35,0,0,1,16.2,11.4a.85.85,0,0,0,.51-.782V5.9a.85.85,0,0,0-.232-.583,10.2,10.2,0,0,0-7.423-3.2Z",
    transform: "translate(11.123 3.514)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6078",
    d: "M12.283,7.567A15.072,15.072,0,0,0,3.175,21.442v3.6a4.11,4.11,0,0,0,4.119,4.119H33.056a4.11,4.11,0,0,0,4.119-4.119v-3.6A15.073,15.073,0,0,0,28.069,7.567h-.355a8.49,8.49,0,0,1-15.082,0Z",
    transform: "translate(0 15.572)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse6149",
    d: "M18.519,7.567A8.455,8.455,0,0,1,7.331,11.321,9.326,9.326,0,0,0,20.668,8.493a15.012,15.012,0,0,0-1.795-.926Z",
    transform: "translate(9.195 15.572)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6146",
    d: "M11.016,7.567q-.138.257-.294.5a15.071,15.071,0,0,1,8.055,13.371v3.6a4.11,4.11,0,0,1-4.119,4.119h1.7a4.11,4.11,0,0,0,4.119-4.119v-3.6A15.073,15.073,0,0,0,11.371,7.567Z",
    transform: "translate(16.698 15.572)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6127",
    d: "M4.233,28.489V12.34a2.544,2.544,0,0,1,2.55-2.55h22.1a2.544,2.544,0,0,1,2.55,2.55v16.15Z",
    transform: "translate(2.342 20.489)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6132",
    d: "M11.377,9.79a2.544,2.544,0,0,1,2.55,2.55v16.15h1.7V12.34a2.544,2.544,0,0,0-2.55-2.55Z",
    transform: "translate(18.148 20.489)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6117",
    d: "M4.233,15.081v1.7h27.2v-1.7Z",
    transform: "translate(2.342 32.198)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6114",
    d: "M5.14,15.346h28.9a1.7,1.7,0,1,1,0,3.4H5.14a1.7,1.7,0,0,1,0-3.4Z",
    transform: "translate(0.585 32.783)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse6229",
    d: "M13.743,3.175a9.35,9.35,0,0,0-7.662,4v1.1a.85.85,0,0,0,.508.782,9.336,9.336,0,0,1,14.3.007.85.85,0,0,0,.51-.782v-1.1a9.35,9.35,0,0,0-7.655-4Z",
    transform: "translate(6.432 5.854)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse6080",
    d: "M24.256,12.79a9.35,9.35,0,1,1-9.35-9.35A9.35,9.35,0,0,1,24.256,12.79Z",
    transform: "translate(5.269 6.44)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6102",
    d: "M4.762,2.6c0,2.008,0,5.716,0,7.721a.85.85,0,0,0,1.7,0c0-2.25,0-6.2,0-8.45Z",
    transform: "translate(3.509 2.961)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle6089",
    d: "M12.773,14.192a2.55,2.55,0,1,1-2.55-2.55A2.55,2.55,0,0,1,12.773,14.192Z",
    transform: "translate(9.952 24.587)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect6122",
    d: "M12.435,15.346a1.7,1.7,0,0,1,0,3.4h1.7a1.7,1.7,0,1,0,0-3.4Z",
    transform: "translate(20.489 32.783)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse6140",
    d: "M9.068,3.44q-.414,0-.827.043A9.345,9.345,0,0,1,8.195,22.1q.435.042.873.043a9.35,9.35,0,1,0,0-18.7Z",
    transform: "translate(11.107 6.44)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6221",
    d: "M5.321,2.229c0,2.288,0,5.934,0,8.088a.837.837,0,0,1-.427.722.828.828,0,0,0,.422.128.848.848,0,0,0,.85-.85c0-2.25,0-6.2,0-8.45Z",
    transform: "translate(3.807 2.961)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle6237",
    d: "M8.2,11.791a2.545,2.545,0,0,1,0,4.8,2.549,2.549,0,1,0,0-4.8Z",
    transform: "translate(11.122 24.587)",
    fill: "#63c5b7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralTotalundergrad);
export default __webpack_public_path__ + "static/media/university-general-totalundergrad.4a4aa000d2aa52fe32d5495a20984b6f.svg";
export { ForwardRef as ReactComponent };